export default ({ app, store }) => {
  // Track registration steps on route change
  app.router.afterEach((to) => {
    if (
      to.name &&
      to.name.startsWith('registration-') &&
      to.name !== 'registration-confirm-exit'
    ) {
      // Track unique step visited
      store.dispatch('registration/trackStep', to.name)
    }
  })
}
